<script>
import { checkRpsStatus } from '@/apis/payment';

export const RPS_STATUS = {
  blocked: 'Blocked',
  pending: 'Pending Review',
  approved: 'Approved',
};

export const SCREENING_TYPE = {
  product: 'product',
};

const rpsStatusKey = '__rps_status__';

const navToHomePage = () => (window.location.href = '/');

export default {
  methods: {
    showRpsBlocked() {
      const { e2OpenAppealData = '' } = window.exportControlConfig || {};
        return this.$alert(this.$t('billing.rps_no_purchase', [e2OpenAppealData]),  this.$t('billing.please_note'), {
        confirmButtonText: this.$t('billing.return_home'),
        dangerouslyUseHTMLString: true,
        beforeClose: navToHomePage,
      });
    },
    showRpsPending() {
      let msg = this.$t('billing.rps_still_processing');
      const cachedRpsStatus = sessionStorage.getItem(rpsStatusKey);
      sessionStorage.removeItem(rpsStatusKey);
      const { isE2OpenEnabled, e2OpenOnlineRealtimeEvent} = window.exportControlConfig || {};
       if(isE2OpenEnabled && e2OpenOnlineRealtimeEvent){
        msg = this.$t('billing.rps_block_new_pending');
       }
      if(cachedRpsStatus === RPS_STATUS.pending){
        msg = this.$t('billing.rps_block_new_pending');
      }
      return this.$alert(msg, this.$t('billing.please_note'), {
        confirmButtonText: this.$t('billing.return_home'),
        beforeClose: navToHomePage,
      });
    },
    mx_rpsPendingLimit(){
       const { isE2OpenEnabled, isE2OpenRPSPending} = window.exportControlConfig || {};
       if(isE2OpenEnabled && isE2OpenRPSPending){
          this.rpsNoEdit =  true
       }
    },
    mx_asyncRpsBlock() {
      const { isE2OpenEnabled, isE2OpenRPSBlocked } = window.exportControlConfig || {};
      if (isE2OpenEnabled !== true) return;
      if (isE2OpenRPSBlocked === true) {
        this.showRpsBlocked();
      }
    },
    isSyncRps(countryCode) {
      const exportControlConfig = window.exportControlConfig || {};
      const { isE2OpenSyncEnabled = false, e2openSyncHighRiskCountries: e2openSyncHighRiskCountriesStr = '' } =
        exportControlConfig;
      if (!isE2OpenSyncEnabled) return false;
      const e2openSyncHighRiskCountries = e2openSyncHighRiskCountriesStr.split(',') || [];
      return e2openSyncHighRiskCountries.includes(countryCode);
    },
    mx_isHighRiskCountries(countryCode) {
      const exportControlConfig = window.exportControlConfig || {};
      const { e2openHighRiskCountries } =  exportControlConfig;
      return countryCode && e2openHighRiskCountries.includes(countryCode);
    },
    mx_checkRpsModalRequired(status) {
      if (!status) return false;
      if (status === RPS_STATUS.blocked) {
        this.showRpsBlocked();
        return true;
      }
      if (status === RPS_STATUS.pending) {
        this.showRpsPending();
        return true;
      }
      return false;
    },
    async mx_checkApiRpsModalRequired(billToContactInfo, soldToContactInfo, planCodes = []) {
      const isSync = [
        billToContactInfo?.country,
        soldToContactInfo?.country,
        // billToContactInfo?.accountHq,
        // soldToContactInfo?.accountHq,
      ]
        .filter((x) => !!x)
        .some((x) => this.isSyncRps(x));
      const payload = {
        billToContact: JSON.stringify(billToContactInfo),
        soldToContact: JSON.stringify(soldToContactInfo),
        rpsScreeningType: isSync ? 'sync' : 'async',
        planCodes
        // extra params not required
      };
      const response = await checkRpsStatus(payload);
      const e2openStatus = response?.result?.e2openStatus ?? '';
      //OBT-1622 only show modal when e2open_check res blocked
      if(e2openStatus === RPS_STATUS.blocked){
        return this.mx_checkRpsModalRequired(e2openStatus);
      } else {
        return false
      }
    },
    mx_checkE2Open(countryCode){
      const e2openInfo = window.exportControlConfig
      if(e2openInfo.isE2OpenEnabled && countryCode){
        return e2openInfo.e2openHighRiskCountries?.includes(countryCode) ||
          e2openInfo.e2openSyncHighRiskCountries?.includes(countryCode)
      }
      return false
    },
    mx_getLegacyFlowPath() {
      const { origin, search } = window?.location;
      const isLoggedIn = this.$context.is.loggedIn;
      const pathName = isLoggedIn ? "/account/billing/buy" : "/buy";
      const goLegacy = "&legacyUI=true"
      return `${origin}${pathName}${search}${goLegacy}`;
    },
  },
};
</script>
<style>
.zm-message-box__message{
  line-height: 1.5;
}
</style>
